import gql from 'graphql-tag';

export const removeStudentFromCourseMutation = gql`
  mutation removeStudentFromCourse($userId: String!, $courseId: String!) {
    removeStudentFromCourse(userId: $userId, courseId: $courseId)
  }
`;
